import Layout from 'components/layout/Layout';
import Meta from 'components/Meta';
import StoryTopPhotos from 'components/story/StoryTopPhotos';
import StoryAbout from 'components/story/StoryAbout';
import StoryItem from 'components/story/StoryItem';
import StoryFooter from 'components/story/StoryFooter';

export default function StoryPage() {
  return (
    <Layout>
      <Meta
        title="Our Story ― Hangboard trainings in your pocket"
        description="Fingy arrived as a training guide for climbers, who strive to prepare for the rocks - as much as we do."
      />
      <StoryTopPhotos />
      <StoryAbout />
      <StoryItem photo="/assets/story/storyBig1.jpg">
        <p>
          <strong>Fingy</strong> was created in the heart of a rock climbing
          paradise, surrounded by the scenery of sandstone cliffs. We live and
          work amid the biggest sandstone canyon in Europe,{' '}
          <strong>Elbe Valley</strong>.
        </p>
        <p>
          Rock climbing has its long tradition here and the community of
          climbers is large, thanks to which we receive a lot of relevant
          feedback on Fingy. Our office is located thirty minutes away from{' '}
          <strong>thousands of climbing paths</strong> and hundreds of boulders,
          as well as many indoor climbing options.
        </p>
      </StoryItem>
      <div className="Container">
        <h3>Train with the experienced</h3>
        <p className="Lead Lead--small" style={{ maxWidth: 500 }}>
          We learn from the most experienced climbers in Europe and we wish the
          same for you.
        </p>
      </div>
      <StoryItem photo="/assets/story/storyBig2.jpg" right>
        <p>
          <strong>Edita Vopatová</strong> (27) is our ambassador. She belongs to
          the greatest climbers in Czech Republic and in Europe. Her toughest
          climbs belong in <strong>9/10 UIAA</strong> category.
        </p>
        <p>
          Edita found - and is currently leading - climbing school called{' '}
          <a
            href="http://en.easyclimbing.cz/?utm_source=fingy"
            rel="noopener noreferrer"
            target="_blank"
          >
            Easy Climbing
          </a>
          . Settled in the mountains, they teach rock climbing to enthusiasts of
          all ages and skill levels.
        </p>
      </StoryItem>
      <div className="Container">
        <h3>What does it mean to be “fingy”?</h3>
        <p className="Lead Lead--small">
          Fingy is an english adjective describing a climbing problem too
          difficult for a climber to hold on to or go over.
        </p>
      </div>
      <StoryItem photo="/assets/story/storyBig3.jpg">
        <p>
          <strong>Fingy</strong> [’f:ngy’] - adjective.
        </p>
        <p>
          1, If there is a climbing problem (boulder, crux) too difficult for
          fingers to hold on to and thus requires for the climber to train.
        </p>
        <p>
          2, When a climber has great strength in his/her fingers, than he/she
          is called a “fingy climber”.
        </p>
      </StoryItem>
      <StoryFooter />
    </Layout>
  );
}
